import { render, staticRenderFns } from "./InsClause.vue?vue&type=template&id=60b1e8b1&scoped=true"
import script from "./InsClause.vue?vue&type=script&lang=js"
export * from "./InsClause.vue?vue&type=script&lang=js"
import style0 from "./InsClause.vue?vue&type=style&index=0&id=60b1e8b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1e8b1",
  null
  
)

export default component.exports